@if (isLoading()) {
	<div class="d-flex justify-content-center align-items-center h-400">
		<mat-spinner></mat-spinner>
	</div>
} @else {
	<div mat-dialog-title>
		<div class="w-100 d-flex justify-content-between align-items-center mb-2">
			Check-listy
			<button mat-raised-button color="primary" (click)="importCheckLists()">Importuj z produktu</button>
		</div>
		<div class="w-100 d-flex justify-content-center align-items-center my-2">
			<mat-progress-bar mode="determinate" [value]="itemsDoneProgress()"></mat-progress-bar>
			<span class="ms-2"> {{ itemsSelectedOrRejectedCount() }}/{{ checkLists().length }} </span>
		</div>
		<div class="d-flex justify-content-between align-items-center">
			<mat-form-field class="w-100" appearance="outline">
				<mat-label>Dodaj checklist...</mat-label>
				<input matInput [(ngModel)]="checkListToAddName" />
			</mat-form-field>

			<button
				(click)="addCheckListItem()"
				[disabled]="!checkListToAddName()"
				class="d-flex justify-content-center align-items-center ms-2"
				mat-icon-button
				color="primary"
			>
				<i class="fa-solid fa-plus"></i>
			</button>
		</div>
	</div>

	<mat-dialog-content>
		<ul class="checklist">
			@for (group of checkListsByGroup(); track group.groupName) {
				<h5 class="my-2">
					{{ group.groupName === '' ? 'Inne' : group.groupName }}
				</h5>
				@for (item of group.checkLists; track item.id; let i = $index) {
					<li
						[ngClass]="{
							'border-bottom': $last === false,
						}"
						class="py-2 d-flex justify-content-between align-items-center"
					>
						<div class="w-75 d-flex justify-content-center align-items-center">
							<div class="d-flex w-50 justify-content-center align-items-center">
								<mat-checkbox
									class="w-25"
									color="primary"
									[checked]="item.selected"
									(change)="updateSelected($event.checked, item.id)"
								></mat-checkbox>

								<span
									class="status-badge w-75 justify-content-center"
									[ngClass]="{
										'status--todo': item.status === CheckListStatus.TODO,
										'status--inprogress': item.status === CheckListStatus.IN_PROGRESS,
										'status--done': item.status === CheckListStatus.DONE,
										'status--rejected': item.status === CheckListStatus.REJECTED,
									}"
									[matMenuTriggerFor]="menu"
									tabindex="0"
									role="button"
								>
									@switch (item.status) {
										@case (CheckListStatus.TODO) {
											Do zrobienia
										}
										@case (CheckListStatus.IN_PROGRESS) {
											W trakcie
										}
										@case (CheckListStatus.DONE) {
											Gotowe
										}
										@case (CheckListStatus.REJECTED) {
											Odrzucone
										}
										@default {
											{{ item.status }}
										}
									}
								</span>
							</div>

							<span
								[ngClass]="{
									'text-line-through': item.status === CheckListStatus.REJECTED,
								}"
								class="px-2 w-70"
							>
								{{ item.name }}
							</span>

							<mat-menu #menu="matMenu" class="status-menu" xPosition="after" yPosition="below">
								@for (status of statuses; track status) {
									<button mat-menu-item (click)="updateStatus(item.id, status)">
										<span
											class="status-option"
											[ngClass]="{
												'status--todo': status === CheckListStatus.TODO,
												'status--inprogress': status === CheckListStatus.IN_PROGRESS,
												'status--done': status === CheckListStatus.DONE,
												'status--rejected': status === CheckListStatus.REJECTED,
											}"
										>
											@switch (status) {
												@case (CheckListStatus.TODO) {
													Do zrobienia
												}
												@case (CheckListStatus.IN_PROGRESS) {
													W trakcie
												}
												@case (CheckListStatus.DONE) {
													Gotowe
												}
												@case (CheckListStatus.REJECTED) {
													Odrzucone
												}
												@default {
													{{ status }}
												}
											}
										</span>
									</button>
								}
							</mat-menu>
							<button
								class="mx-2 d-flex justify-content-center align-items-center delete-btn"
								mat-icon-button
								color="warn"
								(click)="deleteCheckListItem(item.id)"
							>
								<i class="fa-solid fa-trash"></i>
							</button>
						</div>
						<div class="mx-2 z-2 bg-white">
							<mat-form-field appearance="outline">
								<mat-label>Termin wykonania</mat-label>
								<input
									matInput
									[matDatepicker]="picker"
									[ngModel]="item.deadline"
									(ngModelChange)="onDeadlineChange(item.id, $event)"
								/>
								<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
								<mat-datepicker #picker></mat-datepicker>
							</mat-form-field>
						</div>

						<div class="bg-white w-25 d-flex align-items-center">
							<mat-form-field class="w-100" appearance="outline">
								<mat-label>Notatka</mat-label>
								<input
									[(ngModel)]="item.note"
									(focus)="onNoteFocus(item.id, item.note)"
									(blur)="onNoteBlur(item.id, item.note)"
									matInput
								/>
							</mat-form-field>
						</div>
					</li>
				}
			}
		</ul>
	</mat-dialog-content>
}
